import { H_REFERENCIAL_SECTOR } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import SectorAction from '../actions/SectorAction'
import { PATH_REFERENCIAL_RPQS_LINK } from 'home/constants/RouteConstants'
import { Box } from '@mui/material'

const SectorRouterApp = ({ rpqs }) => {
    const dispatch = useDispatch()
    const { code } = useParams()

    const navLinks = useMemo(() => {
        if (rpqs) {
            return [{
                icons: 'dashboard',
                name: i18n.dashboard,
                href: `${PATH_REFERENCIAL_RPQS_LINK}sector/${code}/dashboard`,
                habilitation: H_REFERENCIAL_SECTOR,
            }].filter(l => componentHasHabilitations(l.habilitation))
        }
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.sector}/${code}/dashboard`,
            habilitation: H_REFERENCIAL_SECTOR,
        }].filter(l => componentHasHabilitations(l.habilitation))
    }, [code, rpqs])

    useEffect(() => {
        dispatch(SectorAction.fetchSectors())
        if (code !== 'new') {
            dispatch(SectorAction.fetchSector(code))
        }
    }, [dispatch, code])

    return (
        <Box>
            <FixedSlideNav links={navLinks} />
            <Box className='content-page fullscreen' padding={1}>
                <BoundaryError>
                    <Outlet />
                </BoundaryError>
            </Box>
        </Box>
    )
}

SectorRouterApp.propTypes = {
    rpqs: PropTypes.bool,
}

export default SectorRouterApp